import { render } from "./ThinkingIcon.vue?vue&type=template&id=48b36310&ts=true"
import script from "./ThinkingIcon.vue?vue&type=script&lang=ts"
export * from "./ThinkingIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__